import { useCouponsStore } from "../Coupons";
import { useBetslipStore } from "./betslipStore";
import { AddSelectionPayload } from "./betslipTypes";

export const addBetslipSelections = (selections: AddSelectionPayload[]) => {
  const { addSelection, isLocked, clear } = useBetslipStore.getState();
  const { savedCoupons, setSavedCoupon } = useCouponsStore.getState();

  /**
   * Clear betslip and saved coupon
   * If there's a saved coupon and betslip is not locked
   */
  if (savedCoupons.length > 0 && !isLocked) {
    setSavedCoupon([]);
    clear();
  }

  // Add all selections to betslip
  selections.forEach(addSelection);
};

export const deleteBetslipSelections = (ids: string[]) => {
  const { deleteSelection, isLocked, clear } = useBetslipStore.getState();
  const { savedCoupons, setSavedCoupon } = useCouponsStore.getState();

  /**
   * Clear betslip and saved coupon
   * If there's a saved coupon and betslip is not locked
   */
  if (savedCoupons.length > 0 && !isLocked) {
    setSavedCoupon([]);
    clear();
  }

  // Delete all selections from betslip
  ids.forEach(deleteSelection);
};
